<template>
    <div>
    <v-button flat dense rounded color="primary" v-if="user" tour="briefing-4"
              :tour-title="$T('lending point selector')"
              :tour-content="$T('click here to change the lending point')">
        <span  class=" tb-btn-square">
            <i class="q-icon material-icons" aria-hidden="true" style="font-size: 2rem;">store</i>
        </span>
        <span class="gt-xs on-right q-pr-sm capitalize">
                    {{ user.lending_point.description }}
                </span>
        <q-popover fit>
            <q-list dense link>
                <q-item v-close-overlay v-for="lendingPoint in lendingPoints" :key="lendingPoint.id" @click.native="changeUserLendingPoint(lendingPoint)">
                    <q-item-side icon="room"/>
                    {{ lendingPoint.description }}
                </q-item>
            </q-list>
        </q-popover>
    </v-button>


        <q-modal ref="modal" no-backdrop-dismiss no-esc-dismiss>
            <div>
                <v-header
                        :title="$T('select a lending point')"
                        icon="find in page">
                </v-header>
                <card width="100%" style="width: 40vw!important;">
                    <div class="row items-center justify-center">
                        <q-list link>
                            <q-item v-close-overlay v-for="lendingPoint in lendingPoints" :key="lendingPoint.id" :dusk="lendingPoint.description" @click.native="changeUserLendingPoint(lendingPoint)">
                                <q-item-side icon="room"/>
                                {{ lendingPoint.description }}
                            </q-item>
                        </q-list>

                    </div>
                </card>
            </div>
        </q-modal>
    </div>
</template>

<style lang="stylus">
    @import "../../stylus/_variables.styl"

    .flags
        .q-item-avatar
            width $toolbar-icon-height !important
            height $toolbar-icon-height !important

        .q-item-side
            height $toolbar-icon-height !important
</style>

<script>
    import {mapGetters} from 'vuex'
    import {loadMessages} from '../plugins/i18n'
    import {
        QPopover,
        QList,
        QItem,
        QItemSide
    } from 'quasar-framework'
    import axios from "axios";
    import Card from "./Card";
    import VHeader from "./Header";
    import VButton from "./form/VButton";

    export default {
        name: 'LpSelector',
        props: {
            flags: Boolean
        },
        data () {
          return {
              lendingPoints: [],
          }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),

        },

        components: {
            VButton,
            VHeader,
            Card,
            QPopover,
            QList,
            QItem,
            QItemSide
        },
        mounted() {
            this.getUsersLendingPoints();
            if(this.user && this.user.show_lp_selector) {
                this.$refs.modal.show()
            }
        },
        methods: {
            async getUsersLendingPoints () {
                    let {data} = await axios.get(`/api/v1/courier/lending-points/`);
                    this.lendingPoints = data;

            },
            changeUserLendingPoint(lendingPoint) {
                axios.post(`/api/v1/courier/change/lending-point`, {lending_point_id: lendingPoint.id})
                    .then(function () {
                        window.location.reload();
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/LpSelector.vue